<template>
    <div class="bg-box" router="true">
        <button class="item-btn" @click="clickItem(0)" index="/home">
            <el-image class="ico" v-if="index!=0"  src="../../static/letNav/home-u.png"></el-image>
            <el-image class="ico" v-else-if="index==0"  src="../../static/letNav/home-s.png"></el-image>
            <div style="padding: 0px;">
              <span class="title" :class="{'title-s':index==0}">首页</span>
            </div>
        </button>

        <button class="item-btn" @click="clickItem(1)">
            <el-image class="ico" v-if="index!=1"  src="../../static/letNav/yyk-u.png"></el-image>
            <el-image class="ico" v-else-if="index==1"  src="../../static/letNav/yyk-s.png"></el-image>
            <div style="padding: 0px;">
              <span class="title" :class="{'title-s':index==1}">影音库</span>
            </div>
        </button>

        <button class="item-btn" @click="clickItem(2)" index="/login">
            <el-image class="ico" v-if="index!=2"  src="../../static/letNav/user-u.png"></el-image>
            <el-image class="ico" v-else-if="index==2"  src="../../static/letNav/user-s.png"></el-image>
            <div style="padding: 0px;">
              <span class="title" :class="{'title-s':index==2}">{{nickname}}</span>
            </div>
        </button>
    </div>
    
</template>

<script>
export default {
    data(){
        return {
            index:0,//0 首页, 1 影音库, 2 用户中心
            avatar:'',
            nickname:'牛娃圈'
        }
        
    },
    mounted() {
        this.getUserInfo()
    },
    methods: {
        clickItem(i){
            this.index = i
            if(this.index == 0){
                this.$router.push("/home");
            }else if(this.index == 1){
                this.$router.push("/video");
            }else {
                this.$router.push("/userinfo");
            }
        },
        //获取用户详情
        getUserInfo() {
            let parameter = {}
            this.apis.getselfinfo(parameter).then(res => {
                this.avatar = res.selfinfo.avatar
                this.nickname = res.selfinfo.nickname
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.bg-box {
    background-color: rgba(238, 238, 238, 1);
    height: 100vh;
    width: 100%;

    display: flex;
    flex-direction: column;


}
.login-btn {
    margin-top: 20px;
    height: 35px;
    width: 80px;
   
}

.item-btn {
    border: none;
    padding: 20px 0px 20px 0px;
}

.ico {
    width: 28px;
    height: 28px;
}
.title {
    color: rgba(113, 114, 121, 1);
    font-size: 14px;
}
.title-s {
    color: rgba(91, 138, 252, 1);
}

</style>


// WEBPACK FOOTER //
// src/components/content/navbar/NavBar.vue